import ccmr from '../../images/Courses/CourseThumbnail-Crossfit01.png';
import sculpture from '../../images/Courses/CourseThumbnail-Sculpture01.png';
import chw from '../../images/Courses/CourseThumbnail-CHW01.png';
import unp from '../../images/Courses/CourseThumbnail-UNP01.png';
import BannerBG01 from '../../images/ComponentImages/banner01.png';
import BannerBG02 from '../../images/ComponentImages/banner02.png';
import BannerBG03 from '../../images/ComponentImages/banner03.png';

let buyInfo = [
	/* Make sure that you only use four entrys for this array */
	{
		displayName: "C.C.M.R.'S",
		meta: {
			fileName: 'CCMRProgram.pdf',
			fileType: 'pdf',
			fileSize: '9.63 mb',
			pages: 16,
			apiName: 'ccmrs',
		},
		subtitle: '(Crossfit)',
		price: '0.25',
		demoContent: {
			titles: ['C.C.M.R.’S / CONSTANT CARDIO MUSCLE ROUNDS'],
			bannerText: 'There is always room for improvement',
			bannerTextPosition: 'left',
			bannerImage: BannerBG01,
			descriptions: [
				'CONSTANT/CARDIO MUSCLE ROUNDS also known as C.C.M.R’s, is a mixture of exercises emphasizing one muscle group.',
				'The Individual will perform these exercises with extreme focus and constant movement with no breaks until the round is over. C.C.M.R’S are exercises that focus on what I like to call “The Big Four.” Chest, Back, Legs, and Your Cardiovascular System. The prominent role is to create the foundation of your body to manifest itself into something more.',
			],
			warnings: [
				'The C.C.M.R’s Program requires a Gym with a Crossfit setup that has all the compound exercise equipment included and also provides space for functional movement to be able to perform the program exercises properly.',
			],
		},
		thumbnail: ccmr,
	},
	{
		displayName: 'Sculpture',
		meta: {
			fileName: 'SculptureProgram.pdf',
			fileType: 'pdf',
			fileSize: '12.3 mb',
			pages: 32,
			apiName: 'sculpture',
		},
		subtitle: '(BodyBuilding)',
		price: '15.00',
		demoContent: {
			titles: ['Sculpture', 'Intro to Sculpture'],
			bannerText: 'There is always room for improvement.',
			bannerTextPosition: 'left',
			bannerImage: BannerBG02,
			descriptions: [
				'Sculpture is a program created for you to strictly build muscle, change your frame, and make an internal/external difference to your body and well-being.',
				'You have to understand that you aren’t just a person that goes to the gym. You are an artist; you have the responsibility to start working on yourself. It will take great courage and discipline to start changing your own self. Sculpture is based on how much you are putting in each set, each rep, each minute and each second!',
			],
			warnings: [
				'The Sculpture Program requires a Gym or a Workout Setup with standard gym equipment to be able to perform the program exercises properly.',
			],
		},
		thumbnail: sculpture,
	},
	{
		displayName: 'Crafty Home Workouts',
		meta: {
			fileName: 'CraftyHomeWorkoutsProgram.pdf',
			fileType: 'pdf',
			fileSize: '12.2 mb',
			pages: 25,
			apiName: 'chw',
		},
		subtitle: '',
		price: '10.00',
		demoContent: {
			titles: ['Crafty Home Workouts', 'You Can’t Make It to the Gym? Don’t Have A Gym? Still Want to Workout?'],
			bannerText: 'There is always room for improvement.',
			bannerTextPosition: 'right',
			bannerImage: BannerBG03,
			descriptions: [
				'Well Now, you will never miss a workout ever again.',
				'These home workouts are meant to help you with time and consistency. It’s meant to work around your busy and rugged schedule.',
				'There is a bevy of workouts you can individually choose from. These workouts are complex and easy to learn. You just have to meet the workout plan halfway with personal responsibility and self-perseverance for results to reach the maximum.',
			],
			infos: [
				'CraftyHomeWorkouts can be performed anytime & anywhere!',
				'Preferred to Own:',
				'5lbs-10lbs-15lb dumbbells',
				'KettleBells (recommendation)',
				'Loop Bands/ Hip Circle Bands',
				'PullUp Bar access (recommendation)',
				'Resistance Bands',
			],
		},
		thumbnail: chw,
	},
	{
		displayName: 'Upcoming New Programs',
		subtitle: '(Coming Soon)',
		price: '1.00',
		description: 'comming soon',
		thumbnail: unp,
	},
];

export default buyInfo;
